import React from "react";

const DonemOptions = () => {

    const options = [];
    const date = new Date();
    const now = date.getFullYear();

    for (let yil = now; yil >= now - 5; yil--) {

        let month = 12;
        if (yil === now) {
            month = date.getMonth();
        }

        for (let ay = month; ay >= 1; ay--) {
            options.push(`${yil}-${ay < 10 ? '0' + ay : ay}`)
        }
    }

    return options.map((item, index) => (
        <option key={index} value={item}>{item}</option>
    ))

}

export default React.memo(DonemOptions);
